import { useNavigate } from 'react-router-dom'

import overviewJson from '../../demo/fixtures/w2/overview.json'
import { Card, CardHead, Icon, type IconName } from '../../ui'
import styles from './QuickStartCard.module.css'

interface QuickStartItem {
  icon: IconName
  title: string
  sub: string
}

interface OverviewFixture {
  quickStart: QuickStartItem[]
}

const fixture = overviewJson as unknown as OverviewFixture
const routes = ['/create', '/creatives?gen=1', '/analytics'] as const

export function QuickStartCard() {
  const navigate = useNavigate()
  return (
    <Card data-scope="overview-quickstart">
      <CardHead title="快速开始" />
      <div className={styles.list}>
        {fixture.quickStart.map((item, index) => (
          <div
            className={styles.item}
            key={item.title}
            role="button"
            tabIndex={0}
            onClick={() => { void navigate(routes[index] ?? '/overview') }}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault()
                void navigate(routes[index] ?? '/overview')
              }
            }}
          >
            <div className={styles.icon}><Icon name={item.icon} size={18} /></div>
            <div>
              <p className={styles.title}>{item.title}</p>
              <p className={styles.sub}>{item.sub}</p>
            </div>
          </div>
        ))}
      </div>
    </Card>
  )
}
